// extracted by mini-css-extract-plugin
export var bContent = "TwoCols-module--bContent--28940";
export var bImage = "TwoCols-module--bImage--efab7";
export var goicon = "TwoCols-module--goicon--e97f6";
export var image = "TwoCols-module--image--fbd64";
export var item = "TwoCols-module--item--9522a";
export var links = "TwoCols-module--links--1e25d";
export var linktext = "TwoCols-module--linktext--13896";